import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SweetSpotSharedService {
  
  private subHeaderDataSource = new BehaviorSubject<any>(null);
  subHeaderData$ = this.subHeaderDataSource.asObservable();

setSubHeaderData(data: any, tabId?: string) {
  this.subHeaderDataSource.next({
    ...data,
    tabId: tabId || null
  });
}
}
